import TenantBookingPhase from './TenantBookingPhase.vue';

export default TenantBookingPhase;
